import React from 'react'
import Service from '../Service'

const UiUxDesign = () => {
    const title = 'UI/UX Design'
    const description = 'Bug Resistance creates user-centered designs that combine aesthetic excellence with intuitive functionality. Our design team conducts user research, creates wireframes and prototypes, and delivers pixel-perfect interfaces that delight users and drive engagement across web and mobile platforms.'
  return (
    <>
        <Service title={title} description={description} />
    </>
  )
}

export default UiUxDesign
